@if (platformBrowser) {
<div class="page center tiny">
  <div class="animated-circle-icon ginormous orange">
    <app-svg src="/assets/icons/alert-circle.svg"></app-svg>
  </div>
  <h1>Unknown Error</h1>
  <p class="standard-text size-3">An unknown error has occurred. We’ve been notified about this error.</p>
  @if (errorId) {
  <p class="legal"><b>Error-ID: </b>{{ errorId }}</p>
  }
</div>
} @if (!platformBrowser) {
<div class="page center tiny">
  <app-tenant-icon-loader [tenant]="tenant"></app-tenant-icon-loader>
</div>
}
